import React, { Component } from "react";

import { Button, Row, Col } from "antd";

import "./FormButtons.css";

export default class FormButtons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: () => {
        if (this.props.isValid) {
          return this.props.isValid();
        }
        return true;
      },
      handlerOnExit: e => {
        if (this.props.handlerOnExit) {
          return this.props.handlerOnExit();
        }
      },
      handlerOnSubmit: e => {
        if (this.props.handlerOnSubmit) {
          return this.props.handlerOnSubmit(e);
        }
      }
    };
  }

  render() {
    return (
      <Row
        gutter={5}
        type="flex"
        justify={this.props.justify || "space-between"}
        align={this.props.align || "middle"}
        className={((this.props.className || "") + " FormButtons").trim()}
      >
        {!this.props.noPreviousButton && (
          <Col span={this.props.exitColSpan || 10}>
            <Button type="danger" color={"red"} onClick={this.state.handlerOnExit}>
              {this.props.lblExit}
            </Button>
          </Col>
        )}
        <Col span={this.props.submitColSpan || 10}>
          <Button
            disabled={!this.state.isValid() || this.props.inProgress}
            loading={this.props.inProgress}
            type="primary"
            htmlType="submit"
            onClick={this.state.handlerOnSubmit}
          >
            {this.props.lblContinue}
          </Button>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/FormButtons/FormButtons.js